import { useQuery } from "@tanstack/react-query";
import { Course, CourseGroup } from "../../types";
import { executeQuery } from "../../../utils";

export function usePublishedCoursesQuery() {
  return useQuery<{
    courses: Course[];
    groups: CourseGroup[];
  }>({
    queryKey: ["publishedCourses"],
    queryFn: () => executeQuery({ path: "/learner/default/courses/published" }),
    refetchOnWindowFocus: false,
  });
}
